import React from "react";
import { CondensedTypography } from "../styles/typography";
import { styled } from "@mui/material";
import Typography from "@mui/material/Typography";
const MobileView = "xs";

const ResourcesText = styled(CondensedTypography)(({ theme }) => ({
  color: "black",
  fontWeight: 600,
  fontSize: "16px",
  [theme.breakpoints.down(MobileView)]: {
    fontSize: "16px",
  },
}));

const FoundText = styled(CondensedTypography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: "16px",

  color: "black",
  [theme.breakpoints.down(MobileView)]: {
    fontSize: "16px",
  },
}));

export function ResourceCountDisplay({
  articlesCount,
  fullTitle,
  className,
}: {
  fullTitle?: string;
  articlesCount?: number;
  className?: string;
}) {
  return (
    <Typography className={className} component={"div"}>
      {!!articlesCount && fullTitle && (
        <ResourcesText display="inline" className={"citation"}>
          {" "}
          {fullTitle} |{" "}
        </ResourcesText>
      )}
      {!!articlesCount && (
        <FoundText display="inline"> {articlesCount} SOURCES </FoundText>
      )}
    </Typography>
  );
}
